export default "__VITE_ASSET__a5255101__"